import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Card } from 'react-bootstrap';

import { requestList as request } from 'api/sfms/dashboard/notice';
import List from 'components/common-sfims/List';
import { utc2tz } from 'function/convert';
import { RESPONSE_CODE, ROUTER_PATH } from 'types/const';
import comma from 'utils/format/comma';
import format from 'utils/string/format';

/**
 * 대시보드 > 메인 대시보드 - 공지사항
 */
const Notice = () => {
  /* router */
  const history = useHistory();

  /* state */
  // 목록
  const [datas, setDatas] = useState([]);
  // 로딩 여부
  const [isLoading, setIsLoading] = useState(true);
  // 메시지
  const [message, setMessage] = useState({});

  /* watch */
  useEffect(() => {
    requestList();
  }, []);

  /* method */
  // 공지사항 목록 조회 요청
  const requestList = async () => {
    setDatas([]);
    setIsLoading(true);
    setMessage({});

    try {
      const { list = [], code, message } = await request();

      if (code !== RESPONSE_CODE.Success) {
        throw {
          code,
          error: message
        };
      }

      setDatas(list);
    } catch (error) {
      setMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  /* view */
  return (
    <Card>
      <Card.Body className="p-0">
        <div className="scrollbar" style={{ maxHeight: '275px' }}>
          <List
            className={{
              table: 'text-start mb-0',
              thead: 'bg-100 text-900 border-200'
            }}
            columns={[
              {
                text: 'boardNotice',
                className: 'cursor-pointer',
                colSpan: 2,
                onClick: () => history.push(ROUTER_PATH.board.notice.list)
              }
            ]}
            message={message}
            showLoading={isLoading}
            hover
          >
            {datas.map(({ seq, title, noticeCommentCnt, regDt } = {}) => (
              <tr
                key={`datas${seq}`}
                className="cursor-pointer"
                onClick={() => {
                  history.push(
                    format(ROUTER_PATH.board.notice.inform, { seq })
                  );
                }}
              >
                <td className="w-75">
                  {title}
                  {noticeCommentCnt > 0 && (
                    <span className="ms-1 text-primary">
                      ({comma(noticeCommentCnt)})
                    </span>
                  )}
                </td>
                <td className="text-center">{utc2tz(regDt)}</td>
              </tr>
            ))}
          </List>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Notice;
